

































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import BusinessRulesModule from "@/store/modules/business-rules";
import { BusinessRulesState } from "@/models/business-rules/BusinessRulesState";
import { RulesMetrics } from "@/models/business-rules/RulesMetrics";
import { RulesConditions } from "@/models/business-rules/RulesConditions";
import { conditionsSymbols } from "@/helpers/business-rules/conditions-symbols";
import { ruleOperators } from "@/helpers/business-rules/rule-operators";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "RuleConditions"
})

export default class RuleConditions extends Vue {
  // ===== Props ===== //
  @Prop(Number) public readonly idx?: number;
  @Prop(Number) public readonly rulelength?: number;
  @Prop(Object) condition!: RulesConditions;

  // ===== Store ===== //
  @State("businessRules") private readonly businessRules!: BusinessRulesState;
  @businessRules.Action("applyCondition") public applyCondition!: (condition: RulesConditions) => void;
  @businessRules.Action("handleCurrentStep") public handleCurrentStep!: (step: number) => void;

  // ===== Data ===== //
  public symbols = conditionsSymbols;
  public ruleOperators = ruleOperators;
  public createRule: RulesConditions = {
    id: this.condition.id ? this.condition.id : null,
    metric: this.condition.metric,
    comparison: this.condition.comparison ? this.condition.comparison : "",
    value: this.condition.value ? this.condition.value : 0,
    value_metric: this.condition.value_metric,
    operator: this.condition.operator ? this.condition.operator : null,
    uuid: this.condition.uuid ? this.condition.uuid : "",
    metric_alias: this.condition.metric.alias
  }

  // ===== Methods ===== //
  /* istanbul ignore next */
  @Emit("cancelCondition")
  public handleDeleteConditionOperator(condition: RulesConditions) {
    return condition && condition.uuid ? condition.uuid : condition.id;
  }

  @Watch("createdRule", { deep: true })
  public handleAddCondition(createdRule: RulesConditions): void {
    this.applyCondition(createdRule);
  }

  // ===== Computed ===== //
  get createdRule(): RulesConditions {
    return {
      id: this.condition.id,
      metric: this.createRule.metric,
      comparison: this.createRule.comparison,
      value: +this.createRule.value,
      value_metric: this.createRule.value_metric,
      operator: this.createRule.operator,
      uuid: this.condition.uuid,
      metric_alias: this.createRule.metric.alias
    };
  }
  get conditionMetrics(): RulesMetrics[] {
    return this.businessRules.metricsList.filter(metric => metric.is_condition);
  }
  get valueMetrics(): RulesMetrics[] {
    return this.businessRules.metricsList.filter(metric => metric.is_value_metric);
  }
  get showPercent(): boolean {
    return this.condition.metric_alias === "occupancy_percentage";
  }
}

